<template>
  <router-view />
</template>


<script setup>
import {onBeforeUnmount, onMounted} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import ZhiService from "@/core/services/ZhiService";
import {Actions, Mutations} from "@/store/enums/StoreEnums";

const store = useStore();
const router = useRouter();

onMounted(() => {
  function setViewportHeight() {
    store.commit(Mutations.SET_CLINET_HEIGHT, window.innerHeight);
  }
  window.addEventListener('resize', setViewportHeight);
  
  console.log('begin to auth verify');
  if(!ZhiService.checkDirectAccess(window.location.pathname)){
    if(!ZhiService.authVerify()){
      console.log('logout')
      store.dispatch(Actions.LOGOUT).then(() => router.push({ name: "sign-in" }));
    }else{
      store.commit(Mutations.SET_USER, ZhiService.getAccountInfo());
      ZhiService.initAccountInfo();
    }
  }
});
onBeforeUnmount(() => {
  window.removeEventListener('resize', setViewportHeight);
})
</script>

<style lang="scss">
@import "assets/sass/main.scss";
@import "zhivue/assets/fontawesome/css/all.css";
@import "assets/sass/elementplus.css";

.mobile-toast {
  position: fixed;
  left: 50%;
  top: 50% !important; 
  transform: translate(-50%, -50%);
  min-width: 60%;
  max-width: 80%;
  padding: 12px 15px;
  border-radius: 8px;
  background-color: rgba(0,0,0,0.7);
  color: #fff;
  text-align: center;
  z-index: 9999;
}
</style>
